import React, { useState } from "react";
import { Link } from "react-router-dom";
import VideoTut from "../tutorial/videotutorial";
import DocumentRepository from "../tutorial/documentrepository";
import SportReference from "../tutorial/sportreference";

const TutorialTabs = () => {

    const [activeTab, setActiveTab] = useState("Video Tutorial");
    const roleId = localStorage.getItem('RoleId');

    const tabData = [
        {
            icon: <i className="active fa fa-video" />,
            name: "Video Tutorial",
            content: <VideoTut />
        },
        {
            icon: <i className="fa fa-file" />,
            name: "Document Repository",
            content: <DocumentRepository />
        },
        ...((roleId != '7') ? [
            {
                icon: <i className="fa fa-asterisk" />,
                name: "Reference",
                content: <SportReference />
            }
        ] : [])
    ]
    return (
        <>
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <h3 className="text-center mb-40">Tutorial</h3>
                            </div>
                            <div className="row d-flex align-items-center">
                                <div className="col-xl-12 col-lg-12 col-sm-12 col-md-12">
                                    <div className="coach-court-list">
                                        <ul className="nav">
                                            {tabData.map((tab, i) => (
                                                <li key={i}>
                                                    <Link to="#"
                                                        className={tab.name === activeTab ? 'active' : ''}
                                                        onClick={() => setActiveTab(tab.name)}>
                                                        {tab.icon}  {tab.name}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="tab-content mt-2">
                                    {tabData
                                        .filter(tab => tab.name === activeTab)
                                        .map((tab, i) => (
                                            <div key={i}>{tab.content}</div>
                                        ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TutorialTabs;